module.exports = "<div id=\"highcharts-container\" style=\"width:100%;\" [ngStyle]=\"{'height': displayHeight}\"></div>\n"